export const htmlDecode = (input: string): string | null => {
    var doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
};
